import React from 'react'
import { WebhookRequestDetailProps } from './type'
import IMRequestDetail from './IMRequestDetail'

const DingTalkRequestDetail = ({ requestPayload }: WebhookRequestDetailProps) => {
  return <IMRequestDetail requestPayload={requestPayload} targetsKey="at" />
}

export default DingTalkRequestDetail
